import { TimeRangeSelection, useTimeRangeSelection } from './use-time-range-selection';

/**
 * A page's own filter state. The three range fields are owned by the store, so holding
 * them here too would leave writes that look effective and are not.
 */
export type WithoutRange<T> = Omit<T, 'time_range' | 'start_time' | 'end_time'>;

/** The filter a page's data hooks should read: its own state with the stored range on top. */
export function useRangedFilter<T extends object>(pageFilter: T): T & TimeRangeSelection {
  return { ...pageFilter, ...useTimeRangeSelection() };
}
